module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"label":"Tags","new":"New"},"es":{"label":"Etiquetas","new":"Nuevo"},"fr":{"label":"Tags","new":"Nouveau"},"it":{"label":"Tag","new":"Nuovo"},"pt":{"label":"Tags","new":"Novo"},"pl":{"label":"Tagi","new":"Nowe"}}')
  delete Component.options._Ctor
}
